export const FETCH_STAGES_REQUEST = 'FETCH_STAGES_REQUEST';
export const FETCH_STAGES_SUCCESS = 'FETCH_STAGES_SUCCESS';
export const FETCH_AUTOMATION_TRIGGER_SUCCESS = 'FETCH_AUTOMATION_TRIGGER_SUCCESS';
